// Fonction pour normaliser une chaîne (enlever les accents)
export const normalizeString = (str) => {
  return str
    .normalize('NFD') // Décompose les caractères accentués
    .replace(/[\u0300-\u036f]/g, '') // Supprime les accents
    .toLowerCase() // Convertit en minuscules
}

// Fonction de filtrage améliorée pour les membres
export const filterMembers = (members, filters) => {
  return members.filter((member) => {
    const searchNormalized = normalizeString(filters.search || '')
    const companyNormalized = normalizeString(filters.company || '')
    const countryNormalized = normalizeString(filters.country || '')

    // Normalise les champs du membre
    const fullNameNormalized = normalizeString(`${member.firstName} ${member.lastName}`)
    const emailNormalized = normalizeString(member.email)
    const companyMemberNormalized = normalizeString(member.company || '')
    const countryMemberNormalized = normalizeString(member.country || '')

    // Recherche globale (nom, prénom, email)
    const matchesSearch =
      !filters.search ||
      fullNameNormalized.includes(searchNormalized) ||
      emailNormalized.includes(searchNormalized)

    // Filtre par société
    const matchesCompany = !filters.company || companyMemberNormalized.includes(companyNormalized)

    // Filtre par pays
    const matchesCountry = !filters.country || countryMemberNormalized.includes(countryNormalized)

    return matchesSearch && matchesCompany && matchesCountry
  })
}
